export const REDIRECT_ACTION_DELAY_IN_SECONDS = 2000;